module.exports = __webpack_public_path__ + "img/mpumalanga-black-aces.d47ae231.png";